import { render } from "./ViewNotice.vue?vue&type=template&id=8d55c30c"
import script from "./ViewNotice.vue?vue&type=script&lang=js"
export * from "./ViewNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__